import { elementFromHtml } from '../../utils/common-function';
import { getLayerById } from '../../extract/layers';
import { touchesGeometry, graphicToMap, unionGeometries } from '../../extract/graphics';
/**
 * @category custom widgets
 * @example
 * @version 1.0.5 or Higher
 * هذه المهمة تمكن المستخدم من تحديد على الخريطة بناء على الطبقة التى تم اعطائها وشرط لابد من ان اماكن التحديد تكون متجاورة وبعد ذلك يتم تجميع الاماكن المختارة من الخريطه وارسالها الى المستخدم فى شكل واحد
 * ```typescript
 *  let selectedSettings = {
                    mapView: mapView,
                    layer: inspectionLayer,
                    callback: mapClickRespones,
                    parentSelector: '#view'
                }
                momraGisCore.selectedFeatures(selectedSettings);
                ```
*/
export function selectedFeatures(selectedSettings) {
    let index = 0;
    let touchesGeometryList = [];
    let unionGeometriesList = null;
    let features = [];
    let createWidgetButton = elementFromHtml(`
    <button class="esri-widget--button esri-icon-collection geometry-button" id="selectedFeatures-button" title="تحديد بيانات" style="cursor: pointer;"></button>
    `);
    selectedSettings.mapView.ui.add(createWidgetButton, selectedSettings.widgetPosition);
    selectedSettings.mapView.on('click', async (event) => {
        selectedSettings.mapView.hitTest(event, { exclude: selectedSettings.mapView.graphics })
            .then(async function (response) {
            let feature = response.results[0].graphic;
            if (!feature.geometry) {
                return;
            }
            features.push(feature);
            for (index; index < features.length; index++) {
                if (index == 0 && features.length > 0) {
                    addGraghicToMap(selectedSettings.mapView, features[0]);
                    touchesGeometryList.push(features[0]);
                    console.log('index', index);
                    console.log(touchesGeometryList);
                }
                if (features.length > 1) {
                    console.log(features.length - 1);
                    let geometry1 = features[index == 0 ? index : index - 1];
                    let geomerty2 = features[features.length - 1];
                    let isTouches;
                    if (!unionGeometriesList) {
                        isTouches = await touchesGeometry(geometry1.geometry, geomerty2.geometry);
                        if (isTouches) {
                            touchesGeometryList.push(geomerty2);
                            unionGeometriesList = await unionGeometries(touchesGeometryList.map((item) => item.geometry));
                            addGraghicToMap(selectedSettings.mapView, unionGeometriesList);
                            //selectedSettings.callback(unionGeometriesList);
                        }
                        else {
                            features.pop();
                            index -= 1;
                            alert('برجاء اختيار العناصر المجاورة فقط');
                        }
                    }
                    else {
                        isTouches = await touchesGeometry(unionGeometriesList, features[features.length - 1].geometry);
                        if (isTouches) {
                            touchesGeometryList.push(features[features.length - 1]);
                            unionGeometriesList = await unionGeometries(touchesGeometryList.map((item) => item.geometry));
                            addGraghicToMap(selectedSettings.mapView, unionGeometriesList);
                            //selectedSettings.callback(unionGeometriesList);
                        }
                        else {
                            features.pop();
                            index -= 1;
                            alert('برجاء اختيار العناصر المجاورة فقط');
                        }
                    }
                    document.addEventListener('dblclick', function (e) {
                        document.body.classList.remove('crosshair-cursor');
                        selectedSettings.callback(unionGeometriesList);
                    });
                }
            }
        });
    });
    createWidgetButton.addEventListener('click', function () {
        let layerId = getLayerById(selectedSettings.mapView, selectedSettings.layer.id);
        if (!layerId) {
            selectedSettings.mapView.map.add(selectedSettings.layer);
        }
        console.log('add working done!');
        document.body.classList.add('crosshair-cursor');
        index = 0;
        touchesGeometryList = [];
        unionGeometriesList = null;
        features = [];
        selectedSettings.mapView.graphics.removeAll();
    });
}
function polylineSymbol_() {
    let polyline = {
        type: "simple-line",
        color: "blue",
        width: "3px",
        style: "long-dash-dot"
    };
    return polyline;
}
function addGraghicToMap(mapView, feature) {
    let graphicToMapSettings = {
        feature: feature,
        mapView: mapView,
        clear: true,
        polygonSymbol: polylineSymbol_,
        polylineSymbol: polylineSymbol_,
        pointSymbol: polylineSymbol_
    };
    graphicToMap(graphicToMapSettings);
}
